const $ = require('jquery');

/**
 * @param onSubmit {(formId: string) => void}
 * @returns {void}
 */
module.exports = function listenForForm1262Submit(onSubmit) {
    document.querySelectorAll('[data-component="form1262"]').forEach(form1262 => {
        const $form = $(form1262);

        const formId = $form.attr("id");

        $form.on("formvalid.zf.abide", () => onSubmit(formId))
            .on("submit", e => e.preventDefault());
    });
};